import { Link } from 'react-router-dom';
import { PATHS } from 'src/actuators/common/types/Paths';
import { Button } from 'src/common/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';

type Props = {
    searchParams: URLSearchParams;
    fullWidth?: boolean;
}

export const ActuatorsSelectActuatorButton = ({ searchParams, fullWidth }: Props) => (
    <Button
        as={Link}
        size="md"
        className="vss-actuators-select-actuator-button"
        fullWidth={fullWidth}
        to={{
            pathname: PATHS.Accessories,
            search: searchParams.toString(),
        }}
        icon={(
            <div className="vss-actuators-select-actuator-button__icon">
                <ArrowRightIcon/>
            </div>
        )}
    >
        <I18n messageId={MESSAGES.selectDevice}/>
    </Button>
);
